// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"GW-z","sponsoredTooltipWrapper":"HW-z","sponsoredTooltip":"IW-z","newCard":"JW-z"};